/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useMemo } from "react";
import { translate } from "../translations/translations";
import PriceIncreaseIcon from "../../assets/icons/provider/toggleable/IconPriceIncrease";
import CrossIcon from "../../assets/icons/common/toggleable/IconClose";
import ProviderCancellationIcon from "../../assets/icons/provider/toggleable/IconProviderCancellation";
import CancellationRefusedIcon from "../../assets/icons/contract/toggleable/IconDefend";
import WrongInvoiceIcon from "../../assets/icons/provider/toggleable/IconProviderWrongInvoice";
import QuestionMarkIcon from "../../assets/icons/common/toggleable/IconQuestionmark";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import CalendarIcon from "../../assets/icons/common/toggleable/IconCalendar";

export const providerContractFormDefinitions = {
  providerType: providerType,
  reasonForDispute: reasonForDispute,
  opponentReactionToCancellation: opponentReactionToCancellation,
};

function providerType() {
  return {
    options: ["mobile", "dsl", "electricity", "gas", "other"],
  };
}

function reasonForDispute(values: AbstractCase) {
  return useMemo(() => {
    let options = [
      {
        labelText: translate(`${values.name}.reasonForDispute.options.priceIncrease.label`, values),
        labelIcon: <PriceIncreaseIcon />,
        labelIconActive: <PriceIncreaseIcon active />,
        value: "priceIncrease",
        optionHintText: translate(`${values.name}.reasonForDispute.options.priceIncrease.optionHintText`, values),
      },
      {
        labelText: translate(`${values.name}.reasonForDispute.options.serviceNotAsAgreed.label`, values),
        labelIcon: <CrossIcon />,
        labelIconActive: <CrossIcon active />,
        value: "serviceNotAsAgreed",
        optionHintText: translate(`${values.name}.reasonForDispute.options.serviceNotAsAgreed.optionHintText`, values),
      },
      {
        labelText: translate(`${values.name}.reasonForDispute.options.cancellationByProvider.label`, values),
        labelIcon: <ProviderCancellationIcon />,
        labelIconActive: <ProviderCancellationIcon active />,
        value: "cancellationByProvider",
        optionHintText: translate(`${values.name}.reasonForDispute.options.cancellationByProvider.optionHintText`, values),
      },
      {
        labelText: translate(`${values.name}.reasonForDispute.options.cancellationRefused.label`, values),
        labelIcon: <CancellationRefusedIcon />,
        labelIconActive: <CancellationRefusedIcon active />,
        value: "cancellationRefused",
        optionHintText: translate(`${values.name}.reasonForDispute.options.cancellationRefused.optionHintText`, values),
      },
      {
        labelText: translate(`${values.name}.reasonForDispute.options.invoiceIncorrect.label`, values),
        labelIcon: <WrongInvoiceIcon />,
        labelIconActive: <WrongInvoiceIcon active />,
        value: "invoiceIncorrect",
        optionHintText: translate(`${values.name}.reasonForDispute.options.invoiceIncorrect.optionHintText`, values),
      },
    ];

    options.push({
      labelText: translate(`${values.name}.reasonForDispute.options.other.label`, values),
      labelIcon: <QuestionMarkIcon />,
      labelIconActive: <QuestionMarkIcon active />,
      value: "other",
      optionHintText: translate(`${values.name}.reasonForDispute.options.other.optionHintText`, values),
    });

    return options;
  }, [values.providerType]);
}

function opponentReactionToCancellation(values: AbstractCase) {
  return [
    {
      labelText: translate(`${values.name}.opponentReactionToCancellation.options.noReaction.label`, values),
      labelIcon: <CrossIcon />,
      labelIconActive: <CrossIcon active />,
      value: "noReaction",
      optionHintText: translate(`${values.name}.opponentReactionToCancellation.options.noReaction.optionHintText`, values),
    },
    {
      labelText: translate(`${values.name}.opponentReactionToCancellation.options.cancellationRefused.label`, values),
      labelIcon: <CrossIcon />,
      labelIconActive: <CrossIcon active />,
      value: "cancellationRefused",
      optionHintText: translate(`${values.name}.opponentReactionToCancellation.options.cancellationRefused.optionHintText`, values),
    },
    {
      labelText: translate(`${values.name}.opponentReactionToCancellation.options.differentDate.label`, values),
      labelIcon: <CalendarIcon />,
      labelIconActive: <CalendarIcon active />,
      value: "differentDate",
      optionHintText: translate(`${values.name}.opponentReactionToCancellation.options.differentDate.optionHintText`, values),
    },
  ];
}
